import { useEffect } from 'react';
import { GrLogout } from 'react-icons/gr';
import { toast } from 'sonner';
import { useRouter } from 'next/router';
import usePortfolioBalance, { IUserERC20Balance } from '@/hooks/portfolio/usePortfolioBalance';
import FullScreenGuard from '@/components/auth/FullScreenGuard';
import SettingsBackArrow from '@/components/userSettings/SettingsBackArrow';
import { useSession } from '@/contexts/LitSessionProvider';
import { Button } from '@/components/ui/button';
import { useTurnKeyAuth } from '@/hooks/auth/turnkey/useTurnKeyAuth';
export default function SettingsDeletePage() {
  const {
    PKP,
    clearLitSession
  } = useSession();
  const {
    logoutTurnKey
  } = useTurnKeyAuth();
  const {
    data: assetData
  } = usePortfolioBalance({});
  const balances = (assetData as IUserERC20Balance)?.totalUsdValue;
  const router = useRouter();
  useEffect(() => {
    if (!PKP) {
      router.push('/home');
    }
  }, [PKP, router]);
  const handleDeleteAccount = async () => {
    const confirm = window.confirm('Are you sure you want to delete your account? This action is irreversible.');
    if (!confirm) return;
    const deleteResponse = await fetch('/api/auth/deleteAccount');
    const deleteResponseJson = await deleteResponse.json();
    if (deleteResponseJson.error) {
      toast.error('Error deleting your account. Please try again or contact support.', {
        duration: 2000
      });
      return;
    }
    toast.success('Your account has been successfully deleted.', {
      duration: 2000
    });
    await logoutTurnKey();
    clearLitSession();
    window.location.href = '/home';
  };
  return <div className='bg-genius-indigo h-[95vh] overflow-y-clip' data-sentry-component="SettingsDeletePage" data-sentry-source-file="index.tsx">
      <FullScreenGuard data-sentry-element="FullScreenGuard" data-sentry-source-file="index.tsx">
        <div className='flex items-center mt-4 pl-4'>
          <SettingsBackArrow data-sentry-element="SettingsBackArrow" data-sentry-source-file="index.tsx" />
        </div>
        <div className='w-full h-full  flex justify-around flex-col  py-2 px-4 bg-genius-indigo mt-4'>
          <div className='px-4 text-sm text-center'>
            <div className='text-lg font-bold mb-12'>Account Deletion</div>
            You must withdraw all your funds before deleting your account. You currently still have
            ${balances?.toFixed(2)}.<br></br>
            <br></br>
            We recommending exporting your private keys before deleting your account. You will not
            be able to access your wallet after deleting your account.
          </div>
          <Button disabled={balances > 0} onClick={handleDeleteAccount} className='disabled:opacity-50 text-genius-cream rounded-full w-full mx-auto py-2 h-14 bg-red-500' data-sentry-element="Button" data-sentry-source-file="index.tsx">
            <GrLogout className='h-4 w-4 mr-4' data-sentry-element="GrLogout" data-sentry-source-file="index.tsx" />
            Delete Account
          </Button>
        </div>
      </FullScreenGuard>
    </div>;
}